import produce from 'immer';
import { ISubscriptionPlanInitialState, types } from './types';
import { restoreInitialState } from '../../utils/AppUtils';
import { types as AuthTypes } from '../authentication/types';

const initialState: ISubscriptionPlanInitialState = {
    subscriptionPlans: [],
    fetchingSubscriptionPlans: false,
    fetchingSubscriptionPlansError: null,
    loggedInUserPlan: undefined,
    fetchingLoggedInUserPlan: false,
    loggedInUserPlanLoaded: false,
    fetchingLoggedInUserPlanError: null,
    updatingUserPlan: false,
    updatingUserPlanError: null,
    subscribing: false,
    subscribeError: null,
    subscription: undefined,
    adminGrantablePlans: [],
    fetchingAdminGrantablePlans: false,
    grantingCreatorSubscription: false,
    adminCreatorGrantResult: null,
};

const reducer = (state = initialState, action: any) => {
    const { type, payload } = action;

    switch (type) {
        case types.SUBSCRIBE:
            return produce(state, (draftState: typeof initialState) => {
                draftState.subscribing = true;
                draftState.subscribeError = null;
                draftState.subscription = undefined;
            });
        case types.SUBSCRIBE_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.subscribing = false;
                if (payload && payload._id && payload._id !== 'pending') {
                    draftState.subscription = payload;
                }
            });
        case types.SUBSCRIBE_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.subscribing = false;
                draftState.subscribeError = payload;
            });
        case types.GET_SUBSCRIPTION_PLANS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingSubscriptionPlans = true;
            });
        case types.GET_SUBSCRIPTION_PLANS_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingSubscriptionPlans = false;
                draftState.subscriptionPlans = payload;
            });
        case types.GET_SUBSCRIPTION_PLANS_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingSubscriptionPlans = false;
                draftState.fetchingSubscriptionPlansError = payload;
            });
        case types.SET_SUBSCRIPTION:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingLoggedInUserPlan = true;
            });
        case types.SET_SUBSCRIPTION_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingLoggedInUserPlan = false;
                draftState.loggedInUserPlanLoaded = true;
                draftState.subscription = payload ?? undefined;
            });
        case types.SET_SUBSCRIPTION_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingLoggedInUserPlan = false;
                draftState.loggedInUserPlanLoaded = true;
                draftState.fetchingLoggedInUserPlanError = payload;
            });
        case types.UPDATE_SUBSCRIPTION:
            return produce(state, (draftState: typeof initialState) => {
                draftState.updatingUserPlan = true;
            });
        case types.UPDATE_SUBSCRIPTION_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.updatingUserPlan = false;
                draftState.subscription = payload;
            });
        case types.UPDATE_SUBSCRIPTION_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.updatingUserPlan = false;
                draftState.updatingUserPlanError = payload;
            });
        case types.ACTIVATE_CREATOR_SUBSCRIPTION:
            return produce(state, (draftState: typeof initialState) => {
                draftState.updatingUserPlan = true;
            });
        case types.ACTIVATE_CREATOR_SUBSCRIPTION_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.updatingUserPlan = false;
            });
        case types.ACTIVATE_CREATOR_SUBSCRIPTION_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.updatingUserPlan = false;
                draftState.updatingUserPlanError = payload;
            });
        case types.FETCH_ADMIN_CREATOR_GRANT_PLANS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingAdminGrantablePlans = true;
                draftState.adminGrantablePlans = [];
            });
        case types.FETCH_ADMIN_CREATOR_GRANT_PLANS_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingAdminGrantablePlans = false;
                draftState.adminGrantablePlans = Array.isArray(payload) ? payload : [];
            });
        case types.FETCH_ADMIN_CREATOR_GRANT_PLANS_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.fetchingAdminGrantablePlans = false;
            });
        case types.GRANT_CREATOR_SUBSCRIPTION_ADMIN:
            return produce(state, (draftState: typeof initialState) => {
                draftState.grantingCreatorSubscription = true;
                draftState.adminCreatorGrantResult = null;
            });
        case types.GRANT_CREATOR_SUBSCRIPTION_ADMIN_SUCCESS:
            return produce(state, (draftState: typeof initialState) => {
                draftState.grantingCreatorSubscription = false;
                draftState.adminCreatorGrantResult = payload;
            });
        case types.GRANT_CREATOR_SUBSCRIPTION_ADMIN_FAIL:
            return produce(state, (draftState: typeof initialState) => {
                draftState.grantingCreatorSubscription = false;
            });
        case types.CLEAR_ADMIN_CREATOR_GRANT:
            return produce(state, (draftState: typeof initialState) => {
                draftState.adminCreatorGrantResult = null;
                draftState.grantingCreatorSubscription = false;
            });
        case types.RESET_SUBSCRIPTION_DATA:
        case AuthTypes.LOGOUT:
        case AuthTypes.LOGOUT_SUCCESS:
        case AuthTypes.LOGOUT_FAILED:
            return restoreInitialState(state, initialState);
        default:
            return state;
    }
};

export { reducer };
